import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNotes } from '@fortawesome/pro-solid-svg-icons';

import { fetchInsightsPropertyNote } from 'helpers/clarity_api';
import PropertyTags from './property_tags';
import PropertyNoteCard from './property_note_card';
import PropertyNoteForm from './property_note_form';

export default function PropertyActions({ id }) {
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showNoteEditor, setShowNoteEditor] = useState(false);

  const handleSaveNote = (note) => {
    setNote(note);

    setShowNoteEditor(false);
  };

  useEffect(() => {
    fetchInsightsPropertyNote(id)
      .then(setNote)
      .finally(() => setLoading(false));
  }, []);  

  return (
    <div className="d-flex flex-column gap-4" onClick={e => e.stopPropagation()}>
      <div className="d-flex align-items-center gap-2">
        {!loading && !showNoteEditor && isEmpty(note?.body) && (
          <Button variant="outline-primary" onClick={() => setShowNoteEditor(true)}>
            <FontAwesomeIcon icon={faNotes} />
            Add Note
          </Button>
        )}
        <PropertyTags id={id} />
      </div>
      {!loading && !showNoteEditor && note?.id && !isEmpty(note?.body) && (
        <PropertyNoteCard note={note} onEdit={() => setShowNoteEditor(true)} />
      )}
      {!loading && showNoteEditor && (
        <PropertyNoteForm
          note={{ ...note, notable_id: id, notable_type: 'Insights::Property' }}
          onClose={() => setShowNoteEditor(false)}
          onSave={handleSaveNote}
        />
      )}
    </div>
  );
}

PropertyActions.propTypes = {
  id: PropTypes.number.isRequired,
};
